@if ((loading$ | async) === false) {
  @if (mitarbeiterDetail$ | async; as mitarbeiterDetail) {
    <div class="px-4 h-[calc(100vh-145px)] flex flex-col overflow-y-auto">
      @if (mitarbeiterDetail?.lstfix) {
        <div class="flex flex-row w-full mt-3">
          <div class="flex flex-col w-full gap-0.5">
            <div class="soft-overline">
              {{ '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.KONTAKTDATEN.TITEL' | translate }}
            </div>
            <soft-ds-card>
              <soft-ds-card-header>
                <soft-ds-card-leading variant="tinted">
                  <soft-ds-icon name="fa-regular fa-user" />
                </soft-ds-card-leading>
                <soft-ds-card-title>
                  {{ mitarbeiterDetail?.lstfix?.vorname }}
                  {{ mitarbeiterDetail?.lstfix?.zuname }}
                </soft-ds-card-title>
              </soft-ds-card-header>
              <soft-ds-card-body>
                <div class="text-base leading-5">
                  {{ mitarbeiterDetail?.adresse?.strasse }}
                  {{ mitarbeiterDetail?.adresse?.strassenr }}
                </div>
                @if (
                  mitarbeiterDetail?.adresse?.landeskennzeichen !== '' &&
                  mitarbeiterDetail?.adresse?.postleitzahl !== '' &&
                  mitarbeiterDetail?.adresse?.ort !== ''
                ) {
                  <div class="text-base leading-5">
                    {{ mitarbeiterDetail?.adresse?.landeskennzeichen }}
                    @if (
                      mitarbeiterDetail?.adresse?.postleitzahl ||
                      mitarbeiterDetail?.adresse?.ort
                    ) {
                      - {{ mitarbeiterDetail?.adresse?.postleitzahl }}
                      {{ mitarbeiterDetail?.adresse?.ort }}
                    }
                  </div>
                }
                @if (
                  mitarbeiterDetail?.adresse?.nebenstellefa &&
                  mitarbeiterDetail?.adresse?.nebenstellefa !== ''
                ) {
                  <div class="text-base leading-5 w-fit">
                    Nebenstelle: {{ mitarbeiterDetail?.adresse?.nebenstellefa }}
                  </div>
                }
                @if (
                  mitarbeiterDetail.adresse?.telefonfa &&
                  mitarbeiterDetail?.adresse?.telefonfa !== ''
                ) {
                  <a
                    class="text-base leading-5 soft-link w-fit"
                    [href]="
                      'tel:' +
                      $safeNavigationMigration(mitarbeiterDetail?.adresse?.telefonfa)
                    "
                  >
                    {{ mitarbeiterDetail?.adresse?.telefonfa }}
                  </a>
                }
                @if (
                  mitarbeiterDetail?.adresse?.handyfa &&
                  mitarbeiterDetail?.adresse?.handyfa !== ''
                ) {
                  <a
                    class="text-base leading-5 soft-link w-fit"
                    [href]="
                      'tel:' +
                      $safeNavigationMigration(mitarbeiterDetail?.adresse?.handyfa)
                    "
                  >
                    {{ mitarbeiterDetail?.adresse?.handyfa }}
                  </a>
                }
                @if (
                  mitarbeiterDetail?.adresse?.mail &&
                  mitarbeiterDetail?.adresse?.mail !== ''
                ) {
                  <a
                    class="text-base leading-5 soft-link w-fit"
                    [href]="
                      'mailto:' +
                      $safeNavigationMigration(mitarbeiterDetail?.adresse?.mail)
                    "
                  >
                    {{ mitarbeiterDetail?.adresse?.mail }}
                  </a>
                }
              </soft-ds-card-body>
            </soft-ds-card>
          </div>
        </div>
      }
      @if ((mitarbeiterDetail?.dienstplanEintraege?.length || 0) > 0) {
        <div class="flex flex-row w-full mt-4 select-none">
          <div class="flex flex-col w-full gap-0">
            <div class="soft-overline">
              {{ '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.DIENSTPLAN.TITEL' | translate }}
            </div>
            <soft-ds-item-group>
              @for (
                dpEintrag of mitarbeiterDetail?.dienstplanEintraege;
                track dpEintrag
              ) {
                <soft-ds-item>
                  <soft-ds-item-leading class="tabular-nums">
                    {{ dpEintrag.vonzeit | date: 'HH:mm' }} -
                    {{ dpEintrag.biszeit | date: 'HH:mm' }}
                  </soft-ds-item-leading>
                  <soft-ds-item-title>{{ dpEintrag?.taetigkeit }}</soft-ds-item-title>
                </soft-ds-item>
              }
            </soft-ds-item-group>
          </div>
        </div>
      }
      @if ((mitarbeiterDetail?.stempel?.length || 0) > 0) {
        <div class="flex flex-row w-full mt-4">
          <div class="flex flex-col w-full gap-0">
            <div class="soft-overline">
              {{ '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.TITEL' | translate }}
            </div>
            <soft-ds-accordion variant="boxed" class="w-full block select-none">
              @for (stempelEintrag of mitarbeiterDetail.stempel; track stempelEintrag) {
                <soft-ds-accordion-item
                  [class]="stempelEintrag.kzkg === 'K' ? 'stempel-kommt' : 'stempel-geht'"
                >
                  <soft-ds-accordion-header>
                    <soft-ds-accordion-leading variant="tinted">
                      <soft-ds-icon
                        [name]="
                          stempelEintrag.kzkg === 'K'
                            ? 'fa-regular fa-person-to-door'
                            : 'fa-regular fa-house-person-leave'
                        "
                      />
                    </soft-ds-accordion-leading>
                    <soft-ds-accordion-title>
                      {{
                        stempelEintrag.kzkg === 'K'
                          ? ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.KOMMT_HEADER'
                            | translate)
                          : ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.GEHT_HEADER'
                            | translate)
                      }}
                    </soft-ds-accordion-title>
                    <soft-ds-accordion-description>
                      {{ stempelEintrag.zeit | date: 'HH:mm' }}
                    </soft-ds-accordion-description>
                  </soft-ds-accordion-header>
                  <soft-ds-accordion-content>
                    <div class="flex flex-row w-full lg:items-start cursor-default pt-1">
                      <div class="flex flex-col w-full px-[0.825rem] ml-2 pb-3 lg:w-1/2">
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.KOMMT_GEHT'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              stempelEintrag?.kzkg === 'K'
                                ? ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.KOMMT'
                                  | translate)
                                : ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.GEHT'
                                  | translate)
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.TAG'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              $safeNavigationMigration(stempelEintrag?.datum)
                                | date: 'EEEE, dd.MM.yyyy'
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.STEMPEL'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              $safeNavigationMigration(stempelEintrag?.zeit)
                                | date: 'HH:mm'
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.CODE'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              stempelEintrag?.pmscode ||
                                ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.NICHT_ERFASST'
                                  | translate)
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.UEBERNAHMEDATUM'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              $safeNavigationMigration(stempelEintrag?.uebernahmedatum)
                                | format: 'DATE_TIME.SECONDS'
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.ANWENDER'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              stempelEintrag?.anwender ||
                                ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.NICHT_ERFASST'
                                  | translate)
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.GERAET'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              stempelEintrag?.pmsgeraet ||
                                ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.NICHT_ERFASST'
                                  | translate)
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.ERFASSUNGSDATUM'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              $safeNavigationMigration(stempelEintrag?.erfzeit)
                                | date: 'dd.MM.yyyy HH:mm:ss'
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.BEMERKUNG'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              stempelEintrag?.bemerkung ||
                                ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.NICHT_ERFASST'
                                  | translate)
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.TAETIGKEIT'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              stempelEintrag?.taetigkeit ||
                                ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.NICHT_ERFASST'
                                  | translate)
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.KST'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              stempelEintrag?.kst ||
                                ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.NICHT_ERFASST'
                                  | translate)
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.HERKUNFT'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              stempelEintrag?.herkunft ||
                                ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.NICHT_ERFASST'
                                  | translate)
                            }}
                          </p>
                        </div>
                        <div
                          class="flex items-center flex-nowrap nowrap gap-3 text-light text-sm"
                        >
                          <p class="w-full">
                            {{
                              '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.STEMPEL.GELOESCHT'
                                | translate
                            }}
                          </p>
                          <p class="w-full">
                            {{
                              stempelEintrag?.kzloesch ||
                                ('#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.NICHT_ERFASST'
                                  | translate)
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </soft-ds-accordion-content>
                </soft-ds-accordion-item>
              }
            </soft-ds-accordion>
          </div>
        </div>
      }
      @if (termine$ | async; as termine) {
        @if (termine.length > 0) {
          <div class="flex flex-row w-full mt-4 select-none">
            <div class="flex flex-col w-full gap-0">
              <div class="soft-overline">
                {{ '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.TERMINE.TITEL' | translate }}
              </div>
              <soft-ds-item-group>
                @for (termin of termine; track termin) {
                  <soft-ds-item>
                    <soft-ds-item-leading class="tabular-nums">
                      {{ termin.vonzeit | date: 'HH:mm' }} -
                      {{ termin.biszeit | date: 'HH:mm' }}
                    </soft-ds-item-leading>
                    <soft-ds-item-title>{{ termin.taetigkeit }}</soft-ds-item-title>
                    @if (termin.external) {
                      <soft-ds-item-trailing>
                        <soft-ds-icon
                          class="text-xs text-purple-500 dark:text-purple-300"
                          name="fa-regular fa-arrow-up-right-from-square"
                        />
                      </soft-ds-item-trailing>
                    }
                  </soft-ds-item>
                }
              </soft-ds-item-group>
            </div>
          </div>
        }
      }
      @if ((mitarbeiterDetail?.istzeiten?.length || 0) > 0) {
        <div class="flex flex-row w-full mt-4 !pb-5 select-none">
          <div class="flex flex-col w-full gap-0">
            <div class="soft-overline">
              {{ '#PMS_STATUSABFRAGE.MITARBEITER_DETAIL.ISTZEIT.TITEL' | translate }}
            </div>
            <soft-ds-item-group>
              @for (istzeit of mitarbeiterDetail.istzeiten; track istzeit) {
                <soft-ds-item>
                  <soft-ds-item-leading class="tabular-nums flex gap-10 lg:gap-14">
                    <span
                      >{{ istzeit.ist_von | date: 'HH:mm' }} -
                      {{ istzeit.ist_bis | date: 'HH:mm' }}</span
                    >
                    <span>{{ istzeit.ist_sekunden | secondsToHours }}</span>
                  </soft-ds-item-leading>
                  <soft-ds-item-title>{{ istzeit.taetigkeit }}</soft-ds-item-title>
                </soft-ds-item>
              }
            </soft-ds-item-group>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="px-4">
      <div class="flex flex-col w-full mt-3 gap-1">
        <div class="flex flex-row skeleton w-20 rounded"></div>
        <div class="flex flex-row skeleton w-40 rounded"></div>
        <div class="flex flex-row skeleton w-40 rounded" *softRepeat="3"></div>
      </div>
      <div class="flex flex-col w-full mt-4">
        <div class="flex flex-row skeleton w-20 rounded mt-1 mb-1"></div>
        <div class="rounded w-full block !p-0 overflow-hidden">
          <div class="flex flex-row skeleton w-full h-10" *softRepeat="2"></div>
        </div>
      </div>
      <div class="flex flex-col w-full mt-4 gap-1">
        <div class="flex flex-row skeleton w-20 rounded mt-2"></div>
        <div class="rounded w-full block !p-0 overflow-hidden">
          <div class="flex flex-row skeleton w-full h-10" *softRepeat="2"></div>
        </div>
      </div>
      <div class="flex flex-col w-full mt-4">
        <div class="flex flex-row skeleton w-20 rounded mt-1 mb-1"></div>
        <div class="rounded w-full block !p-0 overflow-hidden">
          <div class="flex flex-row skeleton w-full h-10" *softRepeat="2"></div>
        </div>
      </div>
      <div class="flex flex-col w-full mt-4">
        <div class="flex flex-row skeleton w-20 rounded mt-1 mb-1"></div>
        <div class="rounded w-full block !p-0 overflow-hidden">
          <div class="flex flex-row skeleton w-full h-10" *softRepeat="2"></div>
        </div>
      </div>
    </div>
  }
} @else {
  <div class="px-4">
    <div class="flex flex-col w-full mt-3 gap-1">
      <div class="flex flex-row skeleton w-20 rounded"></div>
      <div class="flex flex-row skeleton w-40 rounded"></div>
      <div class="flex flex-row skeleton w-40 rounded" *softRepeat="3"></div>
    </div>
    <div class="flex flex-col w-full mt-4">
      <div class="flex flex-row skeleton w-20 rounded mt-1 mb-1"></div>
      <div class="rounded w-full block !p-0 overflow-hidden">
        <div class="flex flex-row skeleton w-full h-10" *softRepeat="2"></div>
      </div>
    </div>
    <div class="flex flex-col w-full mt-4 gap-1">
      <div class="flex flex-row skeleton w-20 rounded mt-2"></div>
      <div class="rounded w-full block !p-0 overflow-hidden">
        <div class="flex flex-row skeleton w-full h-10" *softRepeat="2"></div>
      </div>
    </div>
    <div class="flex flex-col w-full mt-4">
      <div class="flex flex-row skeleton w-20 rounded mt-1 mb-1"></div>
      <div class="rounded w-full block !p-0 overflow-hidden">
        <div class="flex flex-row skeleton w-full h-10" *softRepeat="2"></div>
      </div>
    </div>
    <div class="flex flex-col w-full mt-4">
      <div class="flex flex-row skeleton w-20 rounded mt-1 mb-1"></div>
      <div class="rounded w-full block !p-0 overflow-hidden">
        <div class="flex flex-row skeleton w-full h-10" *softRepeat="2"></div>
      </div>
    </div>
  </div>
}
